import React from 'react';
import AbstractLibraryFilters from './AbstractLibraryFilters';

export default class MobileFilters extends AbstractLibraryFilters {
  render() {
    return (
      <div>
        {super.render()}
      </div>
    );
  }
}
